import styled from 'styled-components'

const Content = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #eff0f3;
  box-sizing: border-box;
`

const EditContainer = styled.div`
  display: flex;
  height: calc(100vh - 80px);
  align-items: center;
  justify-content: center;
`

const Container = styled.div`
  width: 600px;
  height: 600px;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 630px) {
    width: 100vw;
    height: calc(100vh - 80px);
    border-radius: 0;
  }

  @media (max-width: 420px) {
    height: calc(100vh - 80px);
    border-radius: 0;
  }
`

const FieldContainer = styled.div`
  padding: 50px 50px 10px 50px;

  @media (max-width: 420px) {
    padding: 24px;
  }
`

const User = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;

  @media (max-width: 630px) {
    flex-direction: column;
  }
`

const UserName = styled.div`
  width: 50%;
  text-align: left;

  @media (max-width: 630px) {
    width: 100%;
    text-align: left;
  }
`

const Name = styled.div`
  font-size: 18px;
  font-weight: bold;
`

const UserContact = styled.div`
  width: 50%;
  text-align: right;

  @media (max-width: 630px) {
    text-align: left;
    width: 100%;
  }
`

const UserLocation = styled.div`
  width: 50%;
  text-align: left;
  font-size: 15px;
  color: #a4a9b7;

  @media (max-width: 630px) {
    width: 100%;
  }
`

const SubText = styled.div`
  font-size: 17px;
  color: #000;
`

const ContactInfoText = styled.div`
  font-size: 15px;
  color: #a4a9b7;
`

const TimeContainer = styled.div`
  height: 100px;
  border-radius: 4px;
  border: solid 1px #eff0f3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;

  @media (max-width: 630px) {
    margin-top: 20px;
    height: 70px;
  }
`

const TimeIcon = styled.div`
  width: 100px;
`

const TimeTitle = styled.div`
  width: 100%;
  text-align: left;
`

const TimeTitleText = styled.div`
  padding-left: 20px;
  font-size: 16px;
  font-weight: bold;
`

const ErrorContainer = styled.div`
  box-sizing: border-box;
  padding: 10px 0 5px 0;
  height: 20px;
`

const ButtonContainer = styled.div`
  padding: 48px 50px 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  @media (max-width: 420px) {
    padding: 28px 24px 24px 24px;
  }
`

const StyledFormButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  background-color: #3395fe;
  border: 2px solid #3395fe;
  color: #ffffff;
  height: 46px;
  border-radius: 6px;
  outline: none;
  width: 100%;
`

export {
  Content,
  Container,
  FieldContainer,
  User,
  UserName,
  Name,
  UserContact,
  UserLocation,
  SubText,
  ContactInfoText,
  TimeContainer,
  TimeIcon,
  TimeTitle,
  TimeTitleText,
  ErrorContainer,
  ButtonContainer,
  StyledFormButton,
  EditContainer
}
